// 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
import { customRequestAjax } from '@/axiosApi/index'
import $ajax from '@/axiosApi/ajax_config'
import { appid, dateFormat } from '../assets/common/js/config'

const COS = require('cos-js-sdk-v5')
let cosTmpData = {}
const cos = new COS({
  // getAuthorization 必选参数
  getAuthorization: function(options, callback) {
    // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
    // 异步获取临时密钥
    // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
    // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
    // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
    const credentials = cosTmpData.credentials
    callback({
      TmpSecretId: credentials.tmpSecretId,
      TmpSecretKey: credentials.tmpSecretKey,
      SecurityToken: credentials.sessionToken,
      // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
      StartTime: cosTmpData.startTime, // 时间戳，单位秒，如：1580000000
      ExpiredTime: cosTmpData.expiredTime // 时间戳，单位秒，如：1580000000
    })
  }
})

const cosMethods = {
  isCosSwitch: 1, // 0使用阿里云对象存储 1使用腾讯云对象存储
  // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui Start
  imageLinkParamsKey: 'imageMogr2',
  imageLinkParamsStr: 'imageMogr2/format/jpg', // 转换图片格式
  videoLinkParamsStr: 'ci-process=snapshot&time=1&format=jpg', // 截取视频第一帧
  pathSymbol: function(path) {
    return path.indexOf('?') >= 0 ? '&' : '?'
  },
  // 2024.3.18阿里云迁移-对象存储-动态设置图片参数调整-4 Mod by gaoenhui End
  getKeyParams: function(callback) {
    const url = $ajax.getOssToken_URL()
    customRequestAjax(url).then((res) => {
      if (res.data.code == 200) {
        cosTmpData = res.data
        if (typeof callback == 'function') {
          callback()
        }
      }
    })
  },
  uploadFile: function(data) {
    /*   key, file, size, callback, error
     *
     *   key: ''       // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
     *   file: ''      // 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象
     *   sliceSize: '' // 触发分块上传的阈值，超过5MB使用分块上传，非必须
     *   success: ''   // 上传成功回调
     *   error: ''     // 上传失败回调
     *
     */
    const obj = data ? data : {}
    this.getKeyParams(() => {
      let datestr = `${dateFormat(new Date(), 'year')}${
        dateFormat(new Date(), 'month') < 10 ? '0' : ''
      }${dateFormat(new Date(), 'month')}${
        dateFormat(new Date(), 'day') < 10 ? '0' : ''
      }${dateFormat(new Date(), 'day')}`
      let filetype =
        obj.file.type.indexOf('image/') >= 0
          ? 'Image'
          : obj.file.type.indexOf('video/') >= 0
          ? 'Video'
          : 'Other'

      cos.uploadFile(
        {
          Bucket: cosTmpData.bucket,
          Region: cosTmpData.region,
          Key: `/Uploads/wxmall/${appid}/${datestr}/${filetype}${obj.key}`,
          Body: obj.file,
          SliceSize: obj.sliceSize ? obj.sliceSize : 1024 * 1024 * 5,
          // 上传任务创建时的回调函数，返回一个 taskId，唯一标识上传任务，可用于上传任务的取消（cancelTask），停止（pauseTask）和重新开始（restartTask）
          onTaskReady: function(taskId) {
            /* 非必须 */
            // console.log('onTaskReady：' + taskId)
          },
          // 上传文件的进度回调函数，回调参数为进度对象 progressData
          onProgress: function(progressData) {
            /* 非必须 */
            // console.log('onProgress：' + JSON.stringify(progressData))
          },
          // 每个文件完成或错误回调
          onFileFinish: function(err, data, options) {
            /* 非必须 */
            // console.log('onFileFinish：' + err)
            // console.log('onFileFinish：' + options.Key + '上传' + (err ? '失败' : '完成'))
            if (typeof obj.success == 'function' && !err) {
              obj.success(options.Key.replace('Uploads/', ''))
            }
          }
        },
        function(err, data) {
          // console.log('function：' + err, 'function：' + data)
          if (typeof obj.error == 'function') {
            obj.error(err, data)
          }
        }
      )
    })
  }
}
export default cosMethods
// 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End



// WEBPACK FOOTER //
// ./src/axiosApi/cos.js